import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './Modal';

/* eslint-disable */
const ModalPortal = (props) => ReactDOM.createPortal(
  <Modal {...props} />,
  document.getElementById('modal-root')
);

export default ModalPortal
